import React from 'react';
import { Partner } from '../partnership/types';
import CustomPageBlock, { PageBlockProps } from './page-block';
import { PartnersList } from '../about-page/partners/partners';
import { PARTNERSHIP } from 'src/constants/routes';

export default function CustomPagePartners({ items, title, description, type }: Readonly<PageBlockProps<Partner>>) {
  return (
    <CustomPageBlock title={title} description={description} type={type} path={PARTNERSHIP.path}>
      <PartnersList items={items} />
    </CustomPageBlock>
  );
}
